// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aea0b8b8","239":"f21e5f3d","455":"155a3a1e"}[chunkId] + ".chunk.js";
};